/** Junta classes CSS ignorando `false`, `null` e `undefined`. */
export function classes(...partes: Array<string | false | null | undefined>): string {
  return partes.filter(Boolean).join(" ");
}
